import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { AuthService, User } from "../auth-service/auth.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-auth",
  templateUrl: "./auth.component.html",
  styleUrls: ["./auth.component.css"]
})
export class AuthComponent implements OnInit {
  loginForm: FormGroup;
  errorMessage = null;
  userRes: User;
  islogin: boolean;
  constructor(private authService: AuthService, private router: Router) {}   

  ngOnInit() {
    this.onInitform();
  }
  onClickLogin() {
    const email = this.loginForm.value["email"];
    
    const password = this.loginForm.value["password"];

    this.authService.loginhm(email, password).subscribe(res => {
      this.userRes = res;
      this.islogin = !!this.userRes;
      this.router.navigate(["/pas"]);
    });
  }
  onInitform() {
    this.loginForm = new FormGroup({
      email: new FormControl(null, [Validators.required]),
      password: new FormControl(null, [Validators.required])
    });
  }
}
